/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 11:43:34
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 14:46:34
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Tab/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { Tabs } from 'antd';
//import Pane from 'src/components/Antd/TabPane/TabPane';
const { TabPane: Pane } = Tabs;

const Tab = (props) => {
  const { children, ...rest } = props;
  return <Tabs {...rest}>{children}</Tabs>;
};

const TabTitle = ({ title, isSelect }) => {
  return (
    <div className={`${css.tabTitle} ${isSelect ? css.tabTitleSelected : ''}`}>
      {title}
    </div>
  );
};

const TabsGroup = (props) => {
  const {
    activeKey,
    tabsProps = {},
    onChange,
    panes = [],
    tabsWrapperClassName,
    FixedBelowTabsComponent,
  } = props;

  const generatePanes = () => {
    return panes.map((pane) => {
      const { title, content, key } = pane || {};
      return (
        <Pane
          tab={<TabTitle title={title} isSelect={activeKey === key} />}
          key={key}>
          {content}
        </Pane>
      );
    });
  };
  return (
    <div className={`${css.tabWrapper} ${tabsWrapperClassName || ''}`}>
      <Tab
        renderTabBar={(props, DefaultBar) => {
          return (
            <div className={css.tabsContainer}>
              <DefaultBar {...props} className={css.tabBar} />
              {FixedBelowTabsComponent || null}
            </div>
          );
        }}
        tabBarExtraContent={{
          left: <div className={css.leftRightPlaceholder} />,
          right: <div className={css.leftRightPlaceholder} />,
        }}
        activeKey={activeKey}
        onChange={onChange}
        {...tabsProps}>
        {generatePanes()}
      </Tab>
    </div>
  );
};
export default TabsGroup;
